let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3nrLK")).then(() => parcelRequire('2wbVn'));